function segmentEvents() {
  analytics.ready(function () {
    var promoLinkBlade = document.querySelectorAll('[data-osp="blade"]');
    analytics.trackLink(promoLinkBlade, 'Clicked On-site Promo', {
      promoType: 'Blade'
    });
  
    var promoLinkBlade = document.querySelectorAll('[data-osp="resources-sidebar"]');
    analytics.trackLink(promoLinkBlade, 'Clicked On-site Promo', {
      promoType: 'Resources sidebar'
    });
  
    var promoLinkBlade = document.querySelectorAll('[data-osp="cta-block--beneath-post"]');
    analytics.trackLink(promoLinkBlade, 'Clicked On-site Promo', {
      promoType: 'CTA block (beneath-post)'
    });
  
    var promoLinkBlade = document.querySelectorAll('[data-osp="cta-block--mid-post"]');
    analytics.trackLink(promoLinkBlade, 'Clicked On-site Promo', {
      promoType: 'CTA block (mid-post)'
    });
  });
}